// extracted by mini-css-extract-plugin
export default {"formItem":"FormItem_formItem__l0Jr-","input":"FormItem_input__BlttL","arrow":"FormItem_arrow__IWA54"};